import React from 'react';

import { AnchorButton } from '@shared/components/bootstrap';
import { Currency } from '@shared/components/helpers';

import { RenewalBanner } from '@portal/components/renewals/banner';
import { payURL } from '@portal/config/routes';
import { useAccountNoticesQuery } from '@portal/schema';

import { PaymentPlanBanner } from './payment_plan_banner';

export const Notices: React.FC = () => {
  const { data } = useAccountNoticesQuery();

  if (!data) return null;

  const account = data.account;
  const offerID = account.approvedPaymentPlanOffer?.id;
  const delinquentBalance = account.delinquentBalance ?? 0;
  const delinquent = delinquentBalance > 0;
  const renewalPackages = data.renewalPackages;
  const renewalRejected = data.renewalRejected;

  if (offerID) return <PaymentPlanBanner offerID={offerID} />;

  if (delinquent)
    return (
      <AnchorButton kind="danger" block href={payURL()} className="mt-3 mb-3">
        Uh-oh! You have an outstanding balance of <Currency value={delinquentBalance} /> - Click here to pay now!
      </AnchorButton>
    );

  if (renewalPackages.length > 0 && !renewalRejected) return <RenewalBanner packages={renewalPackages} />;

  return null;
};
